export const MENU_PROPS = {
  PaperProps: { style: { minWidth: '240px' } },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
} as const;
